import { useSettings } from "../tools";
import { useCurrentMeeting } from "../contexts/currentMeeting";
import { useEffect } from "react";
import { conferenceLocalStorage } from "conference/tools";
import { TextField } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { useSettingsStore } from "@dvrt/react-tools";

const DisplayNameSetting = () => {
    const settings = useSettings();
    const currentMeeting = useCurrentMeeting();
    const value = settings.displayName;
    const profile = useSettingsStore(conferenceLocalStorage).profile;

    useEffect(() => {
        if (value) return;

        const invitationName = currentMeeting.getDisplayName(currentMeeting.selfInvitation);
        if (invitationName) settings.update({ displayName: invitationName });
        else if (profile) settings.update({ displayName: profile.name });
    }, [currentMeeting, profile, settings.update, value]);

    return (
        <TextField
            value={value ?? ""}
            onChange={(ev) => settings.update({ displayName: ev.target.value })}
            fullWidth
            size="small"
            label={<FormattedMessage id="meetingPage.prepare.displayName" defaultMessage="Display name" />}
            margin="dense"
            required
        />
    );
};

export default DisplayNameSetting;
